import {Question} from "../models/question";
import {MultipleChoiceQuestion} from "../models/multiple-choice-question";
import {TextboxQuestion} from "../models/textbox-question";
import {ChecklistQuestion} from "../models/checklist-question";
import { QuestionSet } from "../models/question-set";
import {sample} from "lodash";

export class QuestionAnswerPopulator {
    private _:any;

    constructor() {
    }

    populateQuestion(question:Question, questionSet:QuestionSet) {
        let answer:any = null;

        let label = sample(questionSet.labels);
        if (question instanceof MultipleChoiceQuestion) {
            answer = label.id;
        }
        if (question instanceof TextboxQuestion) {
            answer = "Testing String";
        }
        if (question instanceof ChecklistQuestion) {
            answer = new Map<String,String>();
            answer.set(label.id, label.id);
        }
        question.setSavedAnswer(answer, questionSet.labels);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/question-answer-populator.service.ts